import React, { useCallback, useEffect, useRef, useState } from "react";
import { ActionItem } from "../../models/SKArtifact";
import { ActionItem as ChannelActionItem } from "../../models/SKChannel";
import * as Yup from "yup";
import { SKTextArea } from "../../components/SKTextarea";
import { SKSelectOption } from "../../components/SKSelectOption";
import { SKInput } from "../../components/SKInput";
import { DialoageContent } from "../artifacts/create/container/components/ArtifactStateDialog";
import { AddTextAreaField } from "../../components/AddTextAreaField";

export interface ModerationOption {
  title: string;
  value: string;
}
interface ArtifactModerationDialogProps {
  contentId: string;
  action: ActionItem | ChannelActionItem;
  onAction: (contentId: string, action: ActionItem | ChannelActionItem, reason: string, note?: string) => void;
  onCancel: () => void;
  options: ModerationOption[];
  dialogContent: DialoageContent;
}

interface ModerationData {
  reason: string;
  note?: string;
}

const ArtifactModerationDialog = ({ contentId, action, onAction, onCancel, options, dialogContent }: ArtifactModerationDialogProps) => {
  const [moderationData, setModerationData] = useState<ModerationData>({
    reason: options[0].value,
  });
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [enableButton, setEnableButton] = useState<boolean>(false);

  const [isValidForm, setIsValidForm] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  const schema = Yup.object().shape({
    reason: Yup.string().trim().required(),
    note: Yup.string()
      .trim()
      .when("reason", {
        is: (val: string) => {
          return val === "Other";
        },
        then: s => s.required().max(150).min(50),
        otherwise: s => s.notRequired().max(150),
      }),
  });

  // useEffect(() => {
  //   setEnableButton(false);
  // }, [enableButton]);

  useEffect(() => {
    const validate = async (moderationData: ModerationData) => {
      try {
        await schema.validate(moderationData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate(moderationData);
  }, [moderationData]);

  const testValidation = async () => {
    const testData = { reason: "Others", note: "" };
    try {
      await schema.validate(testData, { abortEarly: false });
      console.log("Validation unexpectedly passed");
    } catch (err) {
      setIsValidForm(false);
      console.error("Validation failed as expected:", err);
    }
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
    // testValidation();
  }, []);

  const onInputEvent = async (event: React.FocusEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    if (event.type === "focus") {
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-[290px] h-[652px]">
        <div className="flex flex-col justify-center gap-[15px] h-[481px] content-center items-center pl-[20px] pr-[20px]">
          <div>
            <h2 className="popup-title">{dialogContent?.message}</h2>
          </div>
          <div>
            <p className="popup-sub-title">{dialogContent?.description}</p>
          </div>
          <div className="flex flex-col justify-center gap-[30px] content-center items-center">
            <div className="flex items-center">
              <SKSelectOption
                //value={channelData.country}
                name="reason"
                heading="Reason"
                width={"w-[250px]"}
                options={options}
                isTitleSpace={true}
                placeholder="None"
                onUpdate={e => {
                  setEnableButton(true);
                  const reason = e.target.value;
                  setModerationData(prev => ({ ...prev, reason }));
                }}
                marginBottom="mb-[0px]"
              />
            </div>
            {/* <div className="flex items-center">
              <SKSelectOption
                name="reason"
                value={moderationData.reason}
                heading="Headig"
                options={options}
                onUpdate={(e) => {
                  const reason = e.target.value;
                  setModerationData((prev) => ({ ...prev, reason }));
                }}
                marginBottom="mt-[20px]"
              />
            </div> */}
            <div className="w-full items-center gap-[5px]">
              {/* <SKTextArea
                onChange={(e) => {
                  const note = e.target.value;
                  setModerationData((prev) => ({ ...prev, note }));
                }}
                value={moderationData.note ?? ""}
                title=""
                note=""
                height={30}
                placeholder="Enter text"
                name="note"
                onFocus={onInputEvent}
                charAllowed={150}
              /> */}

              <AddTextAreaField
                value={moderationData.note ?? ""}
                title="Note"
                note=""
                height={30}
                isTitleSpace={true}
                placeholder="Enter text"
                name="note"
                //onFocus={onInputEvent}
                charAllowed={150}
                onChange={e => {
                  const note = e.target.value;
                  setModerationData(prev => ({ ...prev, note }));
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col content-center items-center gap-[20px]">
          <div className="thickseparator"></div>
          <button
            id="action_btn"
            className={`popup-button-action ${
              enableButton ? (dialogContent.destructiv ? "text-[#FF3B30]" : "text-black") : "text-gray-400 !cursor-not-allowed"
            } bg-white`}
            onClick={() => {
              if (enableButton) {
                onAction(contentId, action, moderationData.reason, moderationData.note);
              }
            }}
            disabled={!enableButton}
          >
            {dialogContent?.actionTitle}
          </button>
          {/* <button
            className="text-[#FF3B30] bg-white popup-button"
            onClick={(e) => {
              console.log("Action pressed");
              onAction(
                contentId,
                action,
                moderationData.reason,
                moderationData.note
              );
            }}
            disabled={!isValidForm}
          >
            {dialogContent?.actionTitle}
          </button> */}
          <button className="text-black bg-white popup-button-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtifactModerationDialog;
